import {RemoteGetCalculateReimbursementPreview} from 'data/usecases/private/refund/request-preview';
import {GetCalculateReimbursementPreview} from 'domain/usecases/private/refund/request-preview';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetCalculateReimbursementPreview =
	(): GetCalculateReimbursementPreview =>
		new RemoteGetCalculateReimbursementPreview(
			makeBFFApiUrl(RefundFlowEndPoints.calculateReimbursementPreview),
			makeAuthorizeHttpClientDecorator(),
		);
